import React, { Component } from 'react';

class Labels extends Component {
    constructor(props) {
        super(props)
    }
    render() {
        let account = null;
        let empresa = null;
        let accountName = "-";
        let empresaDenominacion = "-";

        if (this.props.account != undefined) {
            account = this.props.account.find(x => x.seleccionada == true);
            accountName = account.esNueva == true ? <p><i>{account.Descripcion} (nueva)</i></p> : <p>{account.Descripcion}</p>;
        }

        if (this.props.enterprise != undefined) {
            empresa = this.props.enterprise.find(x => x.seleccionada == true);
            empresaDenominacion = empresa.esNueva == true ? <p><i>{empresa.Descripcion} (nueva)</i></p> : <p>{empresa.Descripcion}</p>;
        }

        let descripcionTipoEmpresa = this.props.kindEnterprise.find(x => x.seleccionada == true).Descripcion;

        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-md-12">
                            <label>Producto</label>
                        </div>
                    </div>
                    <div className="row row-bold">
                        <div className="col-md-12">
                            <p>{this.props.administrator.Descripcion} {descripcionTipoEmpresa}</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12"><hr className="separator-line separator-light" /></div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <label>Empresa</label>
                        </div>
                    </div>
                    <div className="row row-bold">
                        <div className="col-md-12">
                            {empresaDenominacion}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12"><hr className="separator-line separator-light" /></div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <label>Cuenta</label>
                        </div>
                    </div>
                    <div className="row row-bold">
                        <div className="col-md-12">
                            {accountName}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12"><hr className="separator-line separator-light" /></div>
                    </div>
                </div>
            </div>
        );
    }
};

export default Labels